import React, { useEffect } from "react";
import useAuthStore from "../../store/useAuthStore";

const Content = () => {
  const { isAuthenticated, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const steps = [
    "Create your account",
    "Verify your identity",
    "Start trading instantly"
  ];

  const handleStartTrading = () => {
    if (isAuthenticated) {
      window.location.href = "/swap";
    } else {
      window.location.href = "/register";
    }
  };

  return (
    <section
      className="py-12 sm:py-16 md:py-20 bg-gray-900 backdrop-blur-sm relative overflow-hidden"
      style={{
        background:
          "radial-gradient(51.47% 93.67% at 92.92% 27.08%, #384991 0%, #161837 72.6%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          {/* Left Column - Graphics */}
          <div className="flex items-center justify-center animate-fade-in-up">
            <div className="w-full h-full animate-float">
              <img
                src="/cover.svg"
                alt="Financial charts and Bitcoin graphics"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Right Column - Get Started Section */}
          <div className="flex flex-col justify-center space-y-6 sm:space-y-8">
            {/* Title */}
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2">
                Get Started in <span className="text-white">Minutes</span>
              </h2>
            </div>

            {/* Steps */}
            <div className="space-y-4 sm:space-y-5">
              {steps.map((step, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#0E1696] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="!text-white font-bold text-sm sm:text-base">
                      {index + 1}
                    </span>
                  </div>
                  <span className="text-white text-base sm:text-lg md:text-xl">
                    {step}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <button
              onClick={handleStartTrading}
              className="bg-[#0E1696] hover:bg-[#0E1696] !text-white font-bold px-8 py-4 rounded-full transition-colors text-base sm:text-lg md:text-xl w-full sm:w-auto"
            >
              Start Trading Now
            </button>
          </div>
        </div>
      </div>

      {/* Custom CSS for animations */}
      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
          animation-delay: 0.8s;
        }
      `}</style>
    </section>
  );
};

export default Content;
